import { useEffect, useState } from "react";
import styles from "./LoadingScreen.module.css";

/** Lasteskjerm med Gjelsten Bolig-logo + progressbar, midt i vinduet. Vises ved
 *  oppstart, fader ut og kaller onDone. Bruker den liggende logoen (den stående,
 *  gjelsten-bolig-staaende.svg, finnes ikke). Faller tilbake til tekst hvis logofilen mangler. */
export function LoadingScreen({ onDone }: { onDone: () => void }) {
  const [fade, setFade] = useState(false);
  const [logoFeil, setLogoFeil] = useState(false);

  useEffect(() => {
    const tFade = setTimeout(() => setFade(true), 1250);
    const tDone = setTimeout(onDone, 1700);
    return () => {
      clearTimeout(tFade);
      clearTimeout(tDone);
    };
  }, [onDone]);

  return (
    <div className={`${styles.screen} ${fade ? styles.fade : ""}`} role="status" aria-label="Laster GB Portal">
      <div className={styles.inner}>
        {logoFeil ? (
          <div className={styles.tekstLogo}>
            <span className={styles.tekstNavn}>Gjelsten Bolig</span>
            <span className={styles.tekstSub}>Portal</span>
          </div>
        ) : (
          <img
            src="/logo/gjelsten-bolig-liggende.svg"
            alt="Gjelsten Bolig"
            className={styles.logo}
            onError={() => setLogoFeil(true)}
          />
        )}
        <div className={styles.barTrack}>
          <div className={styles.barFill} />
        </div>
      </div>
    </div>
  );
}
